/* eslint-disable no-undef */
import { useCallback } from 'react'

export default function useHeapTracker() {
  const trackAction = useCallback((eventName, eventProperties) => {
    if (typeof window !== 'undefined') {
      if (eventProperties) {
        window.heap?.track(eventName, eventProperties)
      } else {
        window.heap?.track(eventName)
      }
    }
  }, [])

  return trackAction
}
